import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import my_logo from "../../assets/images/my_logo4.png";

function TopNavbar() {
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #e5e7eb",
      }}
    >
      <Container fluid className="px-4">
        {/* LINE 1: Logo + Social Icons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "8px",
            paddingBottom: "8px",
            borderBottom: "1px solid #f3f4f6",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          {/* Logo */}
          <Link to="/home" style={{ textDecoration: "none" }}>
            <img src={my_logo} alt="BharatAbroad" style={{ height: "34px" }} />
          </Link>

          {/* Social Icons */}
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <a
              href="https://www.instagram.com/thebharatabroad/"
              target="_blank"
              rel="noreferrer"
              style={{ lineHeight: 0 }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram"
                style={{ height: "20px" }}
              />
            </a>

            <a
              href="https://www.youtube.com/@TheBharatAbroad"
              target="_blank"
              rel="noreferrer"
              style={{ lineHeight: 0 }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/b/b8/YouTube_play_button_icon_%282013%E2%80%932017%29.svg"
                alt="YouTube"
                style={{ height: "20px" }}
              />
            </a>

            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              style={{ lineHeight: 0 }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                alt="LinkedIn"
                style={{ height: "20px" }}
              />
            </a>

            {"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}

            <a
              href="https://wa.me/919XXXXXXXXX"
              target="_blank"
              rel="noreferrer"
              style={{ lineHeight: 0 }}
            >
              <img
                src="https://png.pngtree.com/element_our/md/20180626/md_5b321c98efaa6.jpg"
                alt="WhatsApp"
                style={{ height: "28px" }}
              />
            </a>
          </div>
        </div>

        {/* LINE 2: Navigation (text-only, hover bold) */}
        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          <nav style={{ display: "inline-flex" }}>
            {[
              { to: "/", label: "Home" },
              { to: "/sports", label: "Sports" },
              { to: "/health", label: "Health" },
              { to: "/technology", label: "Technology" },
              { to: "/auto", label: "Auto" },
              { to: "/entertainment", label: "Entertainment" },
              { to: "/immigration", label: "Immigration" },
              { to: "/heritage", label: "Heritage" },
              { to: "/travel", label: "Travel" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                style={{
                  color: "#222",
                  fontSize: "13px",
                  fontWeight: "200",
                  paddingRight: "8px",
                  textDecoration: "none",
                  transition: "font-weight 0.01s ease",
                }}
                onMouseEnter={(e) => (e.target.style.fontWeight = "600")}
                onMouseLeave={(e) => (e.target.style.fontWeight = "400")}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <hr style={{ margin: 0 }} />

        {/* LINE 3: Copyright + Policies */}
        <div
          style={{
            padding: "10px 0",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <p style={{ margin: 0, fontSize: "12px", color: "#6b7280" }}>
            Copyright © {new Date().getFullYear()} BharatAbroad. All rights
            reserved. BharatAbroad is not responsible for the content of
            external sites.
          </p>

          <span style={{ color: "#9ca3af", fontSize: "12px" }}>•</span>

          <Link
            to="/privacy-policy"
            style={{
              fontSize: "12px",
              color: "#6b7280",
              textDecoration: "none",
              fontWeight: "400",
            }}
            onMouseEnter={(e) => (e.target.style.fontWeight = "600")}
            onMouseLeave={(e) => (e.target.style.fontWeight = "400")}
          >
            Privacy Policy
          </Link>

          <span style={{ color: "#9ca3af", fontSize: "12px" }}>•</span>

          <Link
            to="/Advertising-policy"
            style={{
              fontSize: "12px",
              color: "#6b7280",
              textDecoration: "none",
              fontWeight: "400",
            }}
            onMouseEnter={(e) => (e.target.style.fontWeight = "600")}
            onMouseLeave={(e) => (e.target.style.fontWeight = "400")}
          >
            Advertising Policy
          </Link>
        </div>
      </Container>
    </div>
  );
}

export default TopNavbar;
